import React from 'react'
import { useTranslation } from 'react-i18next'
import { CopilotStatus } from './lib/copilotTypes'
import { VoiceWaveIcon, HistoryIcon, NewChatIcon, MinimizeIcon } from './icons'
import { cx } from './cx'
import styles from './index.module.scss'

interface CopilotHeaderProps {
  status: CopilotStatus
  historyOpen: boolean
  onToggleHistory: () => void
  onNewChat: () => void
  onClose: () => void
}

const statusKey = (status: CopilotStatus): string => {
  switch (status) {
    case 'ready':
      return 'copilot-status-online'
    case 'reconnecting':
      return 'copilot-status-reconnecting'
    case 'error':
    case 'closed':
      return 'copilot-status-offline'
    default:
      return 'copilot-status-connecting'
  }
}

const CopilotHeader: React.FC<CopilotHeaderProps> = ({ status, historyOpen, onToggleHistory, onNewChat, onClose }) => {
  const { t } = useTranslation()
  const online = status === 'ready'
  return (
    <div className={styles.header}>
      <div className={styles.avatar}>
        <span className={styles.ring} />
        <VoiceWaveIcon />
      </div>
      <div className={styles.idBlock}>
        <div className={styles.name}>{t('genAI.copilot-title')}</div>
        <div className={styles.status}>
          <span className={cx(styles.statusDot, !online && styles.offline)} />
          {t(`genAI.${statusKey(status)}`)}
        </div>
      </div>
      <button
        className={cx(styles.iconBtn, historyOpen && styles.on)}
        onClick={onToggleHistory}
        title={t('genAI.copilot-conversations')}
        aria-label={t('genAI.copilot-conversations')}>
        <HistoryIcon />
      </button>
      <button className={styles.iconBtn} onClick={onNewChat} title={t('genAI.copilot-new-chat')} aria-label={t('genAI.copilot-new-chat')}>
        <NewChatIcon />
      </button>
      <button className={styles.iconBtn} onClick={onClose} title={t('genAI.copilot-minimize')} aria-label={t('genAI.copilot-minimize')}>
        <MinimizeIcon />
      </button>
    </div>
  )
}

export default CopilotHeader
